import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputAdornment, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@/icons/SearchIcon';
import { StyledTextField } from './SearchField.styles';

interface SearchFieldProps {
  searchTerm: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
}

const SearchField: React.FC<SearchFieldProps> = ({ searchTerm, onSearchChange, onClearSearch }) => {
  const { t } = useTranslation();

  return (
    <StyledTextField
      fullWidth
      placeholder={t('apiFilter.searchPlaceholder')}
      value={searchTerm}
      onChange={onSearchChange}
      size='small'
      slotProps={{
        input: {
          sx: { backgroundColor: 'white', borderRadius: 24 },
          endAdornment: (
            <InputAdornment position='end'>
              {searchTerm ? (
                <IconButton size='small' onClick={onClearSearch}>
                  <ClearIcon fontSize='small' />
                </IconButton>
              ) : (
                <SearchIcon />
              )}
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchField;
